var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { MenuTypes } from '@/models/Menu/Constants';
import { DemographicSettingFormModel, IpAreaSettingFormModel, WeeklyDeliveryScheduleFormModel, } from '.';
import { DeliveryDevices, DeliveryInventories } from '../Constants';
import Defaults from '../Defaults';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
var defaults = Defaults.Campaign;
var AdvancedSettingFormModel = /** @class */ (function () {
    function AdvancedSettingFormModel(item) {
        if (item === void 0) { item = {}; }
        this.disabledDevices = false;
        this.disabledInventories = false;
        this.disabledInventoryListTargeting = false;
        this.disabledOnlyJapaneseDevice = false;
        this.disabledDemographicSetting = false;
        this.disabledIpAreaSetting = false;
        this.disabledWeeklyDeliverySchedule = false;
        this.requiredPhone = false;
        this.requiredMobileApp = false;
        var _a = item, _b = _a.deliveryDevices, deliveryDevices = _b === void 0 ? [] : _b, _c = _a.deliveryInventories, deliveryInventories = _c === void 0 ? [] : _c, _d = _a.inventoryListOptionalIds, inventoryListOptionalIds = _d === void 0 ? [] : _d, _e = _a.onlyJapaneseDevice, onlyJapaneseDevice = _e === void 0 ? defaults.onlyJapaneseDevice : _e, _f = _a.weeklyDeliverySchedule, weeklyDeliverySchedule = _f === void 0 ? defaults.weeklyDeliverySchedule : _f, ipAreaSetting = _a.ipAreaSetting, demographicSetting = _a.demographicSetting, menuType = _a.menuType;
        this.deliveryDevices = deliveryDevices;
        this.deliveryInventories = deliveryInventories;
        this.inventoryListOptionalIds = inventoryListOptionalIds;
        this.onlyJapaneseDevice = onlyJapaneseDevice;
        this.weeklyDeliverySchedule = weeklyDeliverySchedule.map(WeeklyDeliveryScheduleFormModel.assign);
        this.ipAreaSetting = new IpAreaSettingFormModel(ipAreaSetting);
        this.demographicSetting = new DemographicSettingFormModel(demographicSetting);
        this.originalDemographicSetting = cloneDeep(this.demographicSetting);
        this.init(menuType);
    }
    AdvancedSettingFormModel.prototype.init = function (menuType) {
        switch (menuType) {
            case MenuTypes.GeoGenome:
            case MenuTypes.Newspaper:
            case MenuTypes.Pta:
            case MenuTypes.Automobile:
            case MenuTypes.Mansion:
                this.demographicSetting.disabledPrefecture = true;
                this.requiredPhone = true;
                this.requiredMobileApp = true;
                this.deliveryDevices =
                    this.deliveryDevices.length === 0
                        ? [DeliveryDevices.PHONE]
                        : this.deliveryDevices;
                this.deliveryInventories =
                    this.deliveryInventories.length === 0
                        ? __spreadArray([], defaults.deliveryInventories, true) : this.deliveryInventories;
                break;
            case MenuTypes.Retargeting:
                this.disabledWeeklyDeliverySchedule = true;
                this.disabledDevices = true;
                this.disabledInventories = true;
                this.disabledOnlyJapaneseDevice = true;
                this.disabledDemographicSetting = true;
                this.disabledIpAreaSetting = true;
                this.deliveryDevices =
                    this.deliveryDevices.length === 0
                        ? [
                            DeliveryDevices.PC,
                            DeliveryDevices.TABLET,
                            DeliveryDevices.PHONE,
                        ]
                        : this.deliveryDevices;
                this.deliveryInventories =
                    this.deliveryInventories.length === 0
                        ? [
                            DeliveryInventories.MOBILE_APP,
                            DeliveryInventories.MOBILE_WEB,
                            DeliveryInventories.WEB,
                        ]
                        : this.deliveryInventories;
                break;
            case MenuTypes.Office:
                this.disabledOnlyJapaneseDevice = true;
                this.disabledDemographicSetting = true;
                this.disabledIpAreaSetting = true;
                this.requiredPhone = true;
                this.requiredMobileApp = true;
                this.deliveryDevices =
                    this.deliveryDevices.length === 0
                        ? [
                            DeliveryDevices.PC,
                            DeliveryDevices.TABLET,
                            DeliveryDevices.PHONE,
                        ]
                        : this.deliveryDevices;
                this.deliveryInventories =
                    this.deliveryInventories.length === 0
                        ? [
                            DeliveryInventories.MOBILE_APP,
                            DeliveryInventories.MOBILE_WEB,
                            DeliveryInventories.WEB,
                        ]
                        : this.deliveryInventories;
                break;
            case MenuTypes.CustomGeo:
            case MenuTypes.Railway:
            case MenuTypes.Custom:
            case MenuTypes.Geo:
            default:
                this.requiredPhone = true;
                this.requiredMobileApp = true;
                this.deliveryDevices =
                    this.deliveryDevices.length === 0
                        ? __spreadArray([], defaults.deliveryDevices, true) : this.deliveryDevices;
                this.deliveryInventories =
                    this.deliveryInventories.length === 0
                        ? __spreadArray([], defaults.deliveryInventories, true) : this.deliveryInventories;
                break;
        }
    };
    Object.defineProperty(AdvancedSettingFormModel.prototype, "isIncorrectInventoryCombinationWithPC", {
        // PC選択時にWEBが選択されてない
        get: function () {
            if (!this.deliveryDevices.includes(DeliveryDevices.PC)) {
                return false;
            }
            return !this.deliveryInventories.includes(DeliveryInventories.WEB);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdvancedSettingFormModel.prototype, "isIncorrectInventoryCombinationWithMobile", {
        // モバイル選択時にモバイルの配信面が選択されてない
        get: function () {
            if (!this.isSelectedMobileDevice) {
                return false;
            }
            return !this.deliveryInventories.some(function (device) {
                return device === DeliveryInventories.MOBILE_APP ||
                    device === DeliveryInventories.MOBILE_WEB;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdvancedSettingFormModel.prototype, "isIncorrectDeviceCombinationWithMobileInventory", {
        // モバイル配信面を選択時にモバイル端末が選択されていない
        get: function () {
            if (!this.isSelectedMobileInventory) {
                return false;
            }
            return !this.deliveryDevices.some(function (device) {
                return device === DeliveryDevices.TABLET || device === DeliveryDevices.PHONE;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdvancedSettingFormModel.prototype, "isIncorrectDeviceCombinationWithWeb", {
        // WEB配信面を選択時配信デバイス1つもが選択されていない
        get: function () {
            if (!this.deliveryInventories.includes(DeliveryInventories.WEB)) {
                return false;
            }
            return this.isDeviceEmpty;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdvancedSettingFormModel.prototype, "isIncorrectDeviceCombinationWithApp", {
        // アプリ選択時にタブレットまたはスマートフォンが選択されていない
        get: function () {
            if (!this.deliveryInventories.includes(DeliveryInventories.MOBILE_APP)) {
                return false;
            }
            return !this.deliveryDevices.some(function (device) {
                return device === DeliveryDevices.TABLET || device === DeliveryDevices.PHONE;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdvancedSettingFormModel.prototype, "isDeviceEmpty", {
        get: function () {
            return this.deliveryDevices.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdvancedSettingFormModel.prototype, "isInventoryEmpty", {
        get: function () {
            return this.deliveryInventories.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdvancedSettingFormModel.prototype, "isSelectedWebInventory", {
        // Webブラウザを選択しているか
        get: function () {
            return this.deliveryInventories.some(function (device) { return device === DeliveryInventories.WEB; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdvancedSettingFormModel.prototype, "isSelectedMobileInventory", {
        get: function () {
            return this.deliveryInventories.some(function (device) { return device === DeliveryInventories.MOBILE_APP; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdvancedSettingFormModel.prototype, "isSelectedMobileDevice", {
        get: function () {
            return this.deliveryDevices.some(function (device) {
                return device === DeliveryDevices.PHONE || device === DeliveryDevices.TABLET;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdvancedSettingFormModel.prototype, "isChanged", {
        get: function () {
            return !isEqual(this.originalDemographicSetting, this.demographicSetting);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AdvancedSettingFormModel.prototype, "isIpAreaSettingEmpty", {
        get: function () {
            return this.ipAreaSetting.emptyViolation;
        },
        enumerable: false,
        configurable: true
    });
    return AdvancedSettingFormModel;
}());
export { AdvancedSettingFormModel };
